import { BASE_PATH } from '../../shared/types';

export function HelpLink() {
  return <a class="help-link" href={`${BASE_PATH}/help`}>Help</a>;
}
